import React from "react";

import { SelectChangeEvent } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { KeyValue } from "@/models";
import MDTypography from "../md-typography";

export type SelectComponentProps = {
  value: string;
  menuItems: KeyValue[];
  onChange: (value: string) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  readOnly?: boolean;
  fullWidth?: boolean;
  isError?: boolean;
  isLoading?: boolean;
  placeholder?: string;
};

export const SelectComponent = ({
  value,
  menuItems,
  onChange,
  disabled,
  readOnly,
  fullWidth,
  isError,
  label,
  name,
  isLoading,
  placeholder,
}: SelectComponentProps) => {
  const handleOnChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };
  return (
    <>
      {!!label && (
        <MDTypography variant="body2" fontWeight="bold" marginBottom="1.5ch">
          {label}
        </MDTypography>
      )}
      <Select
        id={"select-" + name}
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        fullWidth={fullWidth}
        error={isError}
        onChange={handleOnChange}
        displayEmpty
        renderValue={
          value !== ""
            ? undefined
            : () => (
                <MDTypography style={{ color: "#B9BBBE", fontSize: "0.75rem" }}>
                  {placeholder ?? ""}
                </MDTypography>
              )
        }
        style={{ width: "100%", padding: ".5rem", minHeight: "2.4375em" }}
        endAdornment={
          isLoading ? (
            <InputAdornment position="end" style={{ marginRight: "1.5em" }}>
              <CircularProgress size={20} color="primary" />
            </InputAdornment>
          ) : null
        }
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} value={item.key}>
            <MDTypography variant="body2">{item.value}</MDTypography>
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
